export enum ECompleteMessagesKeys {
  TITLE = "ONBOARDING.COMPLETE.TITLE",
  SUBTITLE = "ONBOARDING.COMPLETE.SUBTITLE",
  MAIL_NOTIFY_INFO = "ONBOARDING.COMPLETE.MAIL_NOTIFY_INFO",
  ALREADY_COMPLETED_TITLE = "ONBOARDING.COMPLETE.ALREADY_COMPLETED_TITLE",
  ALREADY_COMPLETED_SUBTITLE = "ONBOARDING.COMPLETE.ALREADY_COMPLETED_SUBTITLE",
  ALREADY_COMPLETED_MESSAGE = "ONBOARDING.COMPLETE.ALREADY_COMPLETED_MESSAGE",
  SUPPORT_PHONE_LABEL = "ONBOARDING.COMPLETE.SUPPORT_PHONE_LABEL",
  SUPPORT_EMAIL_LABEL = "ONBOARDING.COMPLETE.SUPPORT_EMAIL_LABEL",
  SUPPORT_EMAIL = "ONBOARDING.COMPLETE.SUPPORT_EMAIL",
  SUPPORT_PHONE = "ONBOARDING.COMPLETE.SUPPORT_PHONE",
  CONTACT_SUPPORT_BUTTON = "ONBOARDING.COMPLETE.CONTACT_SUPPORT_BUTTON",
}
